import { ChangeDetectionStrategy, Component, computed, inject, input, output, signal } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import { switchMap } from 'rxjs/operators';
import { LiveFormsTranslateLoaderService } from '../../services/live-forms-translate-loader.service';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'lfe-editor-toolbox',
  templateUrl: './editor-toolbox.component.html',
  styleUrl: './editor-toolbox.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon],
  standalone: true
})
export class EditorToolboxComponent {
  readonly formGroup = input.required<FormGroup>();

  readonly getLiveFormRequested = output<void>();
  readonly getXmlRequested = output<void>();
  readonly getFormattedXmlRequested = output<void>();

  readonly translateService = inject(LiveFormsTranslateLoaderService);

  isOpen = signal(false);

  private formGroupChanges = toSignal(toObservable(this.formGroup).pipe(switchMap((fg) => fg.events)));

  formState = computed(() => {
    this.formGroupChanges();
    const fg = this.formGroup();
    return { dirty: fg.dirty, untouched: fg.untouched, valid: fg.valid, enabled: fg.enabled };
  });
}
